import { render } from "./MReservationCard.vue?vue&type=template&id=526017ef"
import script from "./MReservationCard.vue?vue&type=script&lang=ts"
export * from "./MReservationCard.vue?vue&type=script&lang=ts"
script.render = render

export default script